/** Canonical industry keys — align company industry with template packs */
export const INDUSTRY_OPTIONS = [
  { key: 'healthcare', label: 'Healthcare' },
  { key: 'manufacturing', label: 'Manufacturing' },
  { key: 'it', label: 'IT' },
  { key: 'construction', label: 'Construction' },
  { key: 'logistics', label: 'Logistics' },
  { key: 'education', label: 'Education' },
];

export const SOP_PREFERENCE_OPTIONS = [
    {id: 'Professional', title: 'Professional'}, 
    {id: 'Simple & Clear', title: 'Simple & Clear'},
    {id: 'Formal', title: 'Formal'},
    {id: 'Technical', title: 'Technical'},
    {id: 'Detailed', title: 'Detailed'}
  ];
export const PLAN_STATUS = ['trial', 'active', 'expired', 'cancelled'];
export const PLAN_TYPES = {
  PRO: 'pro',
  BASIC: 'basic',
  ENTERPRISE: 'enterprise'
} as const;

export const PLAN_OPTIONS = [
  { label: 'Pro', value: PLAN_TYPES.PRO, soplimit: 200, userlimit: 5 },
  { label: 'Basic', value: PLAN_TYPES.BASIC, soplimit: 20, userlimit: 0 },
  { label: 'Enterprise', value: PLAN_TYPES.ENTERPRISE, soplimit: 1000, userlimit: 1000 },
];
export type PlanType = typeof PLAN_TYPES[keyof typeof PLAN_TYPES];